import React, {useEffect, useContext} from "react";
// data and utility
import Util from "../../../../util"
// context
import { CatalogueContext } from "../../../../context";
// components
import { Block, HtmlHeader, Scaffolding } from "../../../shared";
import { ActivityPackageLink, Link, Loader } from "../../../controls";

// styling
import "./ActivityPackageList.scss";


export default function ActivityPackageList() {
  // context
  const CC = useContext(CatalogueContext);

  // state 

  // scroll to top when mounting
  useEffect(() => {
    Util.Scroll.scrollToTop()
  }, []);

  /*
  // mount
  useEffect(() => {
    if(CC.isReady) {

    }
  }, [CC.isReady, CC.activityPackages]);
  */

  // pre-render
  let content = <Loader />;
  if(CC.isReady) {
    const items = CC.activityPackages.map(ap => <ActivityPackageLink key={ap._id} activityPackage={ap} />);
    content = <div className="items">{items}</div>;
  }

  // render
  return (
    <Scaffolding>
      <div id="v-activitypackage-list">
        <HtmlHeader title="Erlebnis-Kombinationen" imageUrl={""} />
        <Block>
          <div className="heading">
            <h1>Geschenkideen für unvergessliche Erlebnisse</h1>
          </div>
          <div className="introduction">
            <div className="introduction_inner">
              <p>
                <b>Unsere Aktivitäten lassen sich perfekt zu einem abwechslungsreichen Erlebnis kombinieren.</b>
              </p>
              <p>
                Um dir die Suche nach passenden Kombinationen zu erleichtern, <b>haben unsere Überraschungsexperten ein paar Erlebnis-Pakete für euch zusammengestellt</b>. Ob für Fitness-Fanatiker*innen, Genussmenschen, heimliche Filmhelden, Adrenalin-Freaks oder unheilbare Romantiker*innen, <b>es ist für jeden Geschmack etwas dabei</b>. Das beste daran: du musst nur aussuchen, was du schenken willst, den Rest organisieren wir für dich.
              </p>
              <p>
                <b>Übrigens</b>: Unsere Überraschungstage kannst du natürlich frei individualisieren. Stelle im <Link to="/">Shop</Link> eine ganz eigene Erlebnis-Kombination zusammen. So wird dein Geschenk noch persönlicher und einzigartig.
              </p>
            </div>
          </div>
          {content}
        </Block>
      </div>
    </Scaffolding>
  )
}